import Axios from '../../../../networking/intraceptor';
import { pharmacy_delete_sms, pharmacy_sms_create_message, pharmacy_sms_get_list, pharmacy_sms_sync_message, pharmacy_sms_update_message } from '../../../../networking/urlEndPoints';
import { showToast } from '../../../../utils/helper/helper';

// Action Types
const FETCH_PRESET_MESSAGES_REQUEST = 'FETCH_PRESET_MESSAGES_REQUEST';
const FETCH_PRESET_MESSAGES_SUCCESS = 'FETCH_PRESET_MESSAGES_SUCCESS';
const FETCH_PRESET_MESSAGES_FAILURE = 'FETCH_PRESET_MESSAGES_FAILURE';

const UPDATE_PRESET_MESSAGE_REQUEST = 'UPDATE_PRESET_MESSAGE_REQUEST';
const UPDATE_PRESET_MESSAGE_SUCCESS = 'UPDATE_PRESET_MESSAGE_SUCCESS';
const UPDATE_PRESET_MESSAGE_FAILURE = 'UPDATE_PRESET_MESSAGE_FAILURE';

const DELETE_PRESET_MESSAGE_REQUEST = 'DELETE_PRESET_MESSAGE_REQUEST';
const DELETE_PRESET_MESSAGE_SUCCESS = 'DELETE_PRESET_MESSAGE_SUCCESS';
const DELETE_PRESET_MESSAGE_FAILURE = 'DELETE_PRESET_MESSAGE_FAILURE';

const CREATE_PRESET_MESSAGE_REQUEST = 'CREATE_PRESET_MESSAGE_REQUEST';
const CREATE_PRESET_MESSAGE_SUCCESS = 'CREATE_PRESET_MESSAGE_SUCCESS';
const CREATE_PRESET_MESSAGE_FAILURE = 'CREATE_PRESET_MESSAGE_FAILURE';

const SYNC_PRESET_MESSAGES_REQUEST = 'SYNC_PRESET_MESSAGES_REQUEST';
const SYNC_PRESET_MESSAGES_SUCCESS = 'SYNC_PRESET_MESSAGES_SUCCESS';
const SYNC_PRESET_MESSAGES_FAILURE = 'SYNC_PRESET_MESSAGES_FAILURE';

// Action Creators
const presetMessagesRequest = () => ({
    type: FETCH_PRESET_MESSAGES_REQUEST
});

const presetMessagesSuccess = (data) => ({
    type: FETCH_PRESET_MESSAGES_SUCCESS,
    payload: data
});

const presetMessagesFailure = (error) => ({
    type: FETCH_PRESET_MESSAGES_FAILURE,
    payload: error
});

const updatePresetMessageRequest = () => ({
    type: UPDATE_PRESET_MESSAGE_REQUEST
});

const updatePresetMessageSuccess = (data) => ({
    type: UPDATE_PRESET_MESSAGE_SUCCESS,
    payload: data
});

const updatePresetMessageFailure = (error) => ({
    type: UPDATE_PRESET_MESSAGE_FAILURE,
    payload: error
});

const deletePresetMessageRequest = () => ({
    type: DELETE_PRESET_MESSAGE_REQUEST
});

// const deletePresetMessageSuccess = (id) => ({
//     type: DELETE_PRESET_MESSAGE_SUCCESS,
//     payload: id
// });

const deletePresetMessageFailure = (error) => ({
    type: DELETE_PRESET_MESSAGE_FAILURE,
    payload: error
});

const createPresetMessageRequest = () => ({
    type: CREATE_PRESET_MESSAGE_REQUEST
});

const createPresetMessageSuccess = (data) => ({
    type: CREATE_PRESET_MESSAGE_SUCCESS,
    payload: data
});

const createPresetMessageFailure = (error) => ({
    type: CREATE_PRESET_MESSAGE_FAILURE,
    payload: error
});

const syncPresetMessagesRequest = () => ({
    type: SYNC_PRESET_MESSAGES_REQUEST
});

const syncPresetMessagesSuccess = (data) => ({
    type: SYNC_PRESET_MESSAGES_SUCCESS,
    payload: data
});

const syncPresetMessagesFailure = (error) => ({
    type: SYNC_PRESET_MESSAGES_FAILURE,
    payload: error
});

// Thunk Action
export const presetMessages = (searchQuery = '', pageNumber) => {
    return async (dispatch) => {
        try {
            let params = {}
            if (searchQuery) {
                params.search = searchQuery;
            }

            if (pageNumber && !searchQuery) {
                params.page = pageNumber;
                params.no_of_records = 25; // Assuming default page size
            }

            dispatch(presetMessagesRequest());
            const response = await Axios.get(`${pharmacy_sms_get_list}`, {
                params
            });
            dispatch(presetMessagesSuccess(response.data.data));
        } catch (error) {
            showToast(error?.response?.data?.message || 'Failed to fetch preset messages', 'error');
            dispatch(presetMessagesFailure(error?.response?.data || error.message));
        }
    };
};

export const updatePresetMessage = (id, data) => {
    return async (dispatch) => {
        try {
            dispatch(updatePresetMessageRequest());

            // Create FormData and append the data
            const formData = new FormData();
            formData.append('message_log_id', id);
            formData.append('description', data.description);
            formData.append('message', data.message);

            const response = await Axios.post(`${pharmacy_sms_update_message}`, formData);

            // Create updated message object
            const updatedMessage = {
                id: id,
                description: data.description,
                message: data.message,
                ...response.data.data
            };

            // Dispatch success with updated message
            dispatch(updatePresetMessageSuccess(updatedMessage));
            dispatch(presetMessages()); // Refresh the list to ensure sync with server
            showToast('Preset message updated successfully', 'success');
        } catch (error) {
            showToast(error?.response?.data?.message || 'Failed to update preset message', 'error');
            dispatch(updatePresetMessageFailure(error?.response?.data || error.message));
        }
    };
};

export const deletePresetMessage = (id) => {
    return async (dispatch) => {
        try {
            dispatch(deletePresetMessageRequest());
            await Axios.delete(`${pharmacy_delete_sms}/${id}`);
            // dispatch(deletePresetMessageSuccess(id)); // Pass the id instead of response data
            dispatch(presetMessages()); // Fetch the updated list of preset messages
            showToast('Preset message deleted successfully', 'success');
        } catch (error) {
            showToast(error?.response?.data?.message || 'Failed to delete preset message', 'error');
            dispatch(deletePresetMessageFailure(error?.response?.data || error.message));
        }
    };
};

export const createPresetMessage = (data) => {
    return async (dispatch) => {
        try {
            dispatch(createPresetMessageRequest());
            const response = await Axios.post(`${pharmacy_sms_create_message}`, data);
            dispatch(createPresetMessageSuccess(response.data.data));
            dispatch(presetMessages()); // Fetch the updated list of preset messages
            showToast('Preset message created successfully', 'success');
        } catch (error) {
            showToast(error?.response?.data?.message || 'Failed to create preset message', 'error');
            dispatch(createPresetMessageFailure(error?.response?.data || error.message));
        }
    };
};

export const syncPresetMessages = () => {
    return async (dispatch) => {
        try {
            dispatch(syncPresetMessagesRequest());
            const response = await Axios.post(`${pharmacy_sms_sync_message}`);
            dispatch(syncPresetMessagesSuccess(response.data.data));
            dispatch(presetMessages()); // Fetch the updated list after sync
            showToast('Preset messages synced successfully', 'success');
        } catch (error) {
            showToast(error?.response?.data?.message || 'Failed to sync preset messages', 'error');
            dispatch(syncPresetMessagesFailure(error?.response?.data || error.message));
        }
    };
};

// Initial State
const initialState = {
    smsPreset: {
        presets: {
            data: []
        },
        loading: false,
        error: null,
        updateLoading: false,
        updateError: null,
        deleteLoading: false,
        deleteError: null,
        createLoading: false,
        createError: null,
        syncLoading: false,
        syncError: null
    }
};

// Reducer
const smsPresetReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRESET_MESSAGES_REQUEST:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    loading: true,
                    error: null
                }
            };
        case FETCH_PRESET_MESSAGES_SUCCESS:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    loading: false,
                    presets: action.payload,
                    error: null
                }
            };
        case FETCH_PRESET_MESSAGES_FAILURE:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    loading: false,
                    error: action.payload
                }
            };
        case UPDATE_PRESET_MESSAGE_REQUEST:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    updateLoading: true,
                    updateError: null
                }
            };
        case UPDATE_PRESET_MESSAGE_SUCCESS:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    updateLoading: false,
                    updateError: null,
                    presets: {
                        ...state.smsPreset.presets,
                        data: state.smsPreset.presets.data.map(item =>
                            item.id === action.payload.id
                                ? {
                                    ...item, ...action.payload
                                }
                                : item
                        )
                    }
                }
            };
        case UPDATE_PRESET_MESSAGE_FAILURE:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    updateLoading: false,
                    updateError: action.payload
                }
            };
        case DELETE_PRESET_MESSAGE_REQUEST:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    deleteLoading: true,
                    deleteError: null
                }
            };
        case DELETE_PRESET_MESSAGE_SUCCESS:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    deleteLoading: false,
                    deleteError: null,
                    presets: {
                        ...state.smsPreset.presets,
                        data: state.smsPreset.presets.data.filter(item => item.id !== action.payload)
                    }
                }
            };
        case DELETE_PRESET_MESSAGE_FAILURE:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    deleteLoading: false,
                    deleteError: action.payload
                }
            };
        case CREATE_PRESET_MESSAGE_REQUEST:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    createLoading: true,
                    createError: null
                }
            };
        case CREATE_PRESET_MESSAGE_SUCCESS:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    createLoading: false,
                    createError: null,
                    presets: {
                        ...state.smsPreset.presets,
                        data: [action.payload, ...state.smsPreset.presets.data]
                    }
                }
            };
        case CREATE_PRESET_MESSAGE_FAILURE:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    createLoading: false,
                    createError: action.payload
                }
            };
        case SYNC_PRESET_MESSAGES_REQUEST:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    syncLoading: true,
                    syncError: null
                }
            };
        case SYNC_PRESET_MESSAGES_SUCCESS:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    syncLoading: false,
                    syncError: null
                }
            };
        case SYNC_PRESET_MESSAGES_FAILURE:
            return {
                ...state,
                smsPreset: {
                    ...state.smsPreset,
                    syncLoading: false,
                    syncError: action.payload
                }
            };
        default:
            return state;
    }
};

export default smsPresetReducer;